var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.isInitiailized === true && _vm.DV_hidePartnerOrg !== true)?_c('span',_vm._l((_vm.orgParentList),function(parent_org_uid,index){return _c('span',{key:index+ parent_org_uid},[_c('c7-org-name-label',{attrs:{"orgUid":parent_org_uid}}),_vm._v("\n  >       \n  ")],1)}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d9289b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Labels/c21OrgParentsLabel.vue
// module id = null
// module chunks = 